
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <!-- Spinner full-page pendant le traitement -->
  <div v-if="showFullPageSpinner" class="full-page-spinner-overlay">
    <div class="spinner-container">
      <b-spinner variant="primary" label="Chargement..."></b-spinner>
      <p class="mt-3">{{ inProgress }}</p>
    </div>
  </div>

  <!-- Champ de recherche Adresse (optionnel) -->
  <AdresseRecherche
    v-if="showAddressSearch"
    ref="addressSearchInput"
    :label="content.libRechercheAdresse || 'Rechercher d\'adresse'"
    :no-results-message="content.noResultsMessage || 'Aucune adresse trouvée'"
    :language="currentLanguage"
    :is-service-enabled="isAddressFindEnabled"
    class="mb-1"
    :disabled="isSubmitting"
    @select="handleAddressSelect"
    @error="handleAddressFindError"
  />

  <!-- Séparateur -->
  <hr v-if="showAddressSearch && showSearchSeparator" class="my-2" />

  <ValidationObserver ref="observer" tag="div">
    <!-- Numéro civique et Rue -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libNumeroEtRue"
      rules="required|sans_case_postale|is_valid_address|compteValidation:adresse"
      mode="aggressive"
      tag="div"
    >
      <label>{{ content.libAdresse }}</label>
      <b-form-group label-for="numeroEtRue" class="has-float-label mt-1">
        <b-form-input
          id="numeroEtRue"
          v-model="numeroEtRue"
          v-capitalize
          v-remove-extra-spaces
          trim
          autocomplete="street-address"
          maxlength="52"
          class="mt-0"
          :placeholder="content.libNumeroEtRue"
          :state="getValidationState(validationContext)"
          :disabled="isSubmitting"
        />
        <label for="numeroEtRue" class="pl-0">{{ content.libNumeroEtRue }}</label>
        <ErreurValidation
          id="numeroEtRue-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>

    <!-- Appartement (Optionnel) -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libAppartement"
      rules="sans_case_postale|compteValidation:appartement"
      mode="aggressive"
      tag="div"
    >
      <b-form-group label-for="appartement" class="has-float-label">
        <b-form-input
          id="appartement"
          v-model="appartement"
          v-capitalize
          v-remove-extra-spaces
          trim
          maxlength="8"
          class="mt-0"
          :placeholder="content.libAppartement"
          :state="getValidationState(validationContext)"
          :disabled="isSubmitting"
        />
        <label for="appartement" class="pl-0">{{ content.libAppartement }}</label>
        <ErreurValidation
          id="appartement-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>

    <!-- Ville -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libVille"
      rules="required|min:3|sans_case_postale|compteValidation:ville"
      mode="aggressive"
      tag="div"
    >
      <b-form-group :label="content.libVille" label-for="ville">
        <b-form-input
          id="ville"
          v-model="ville"
          v-capitalize
          v-remove-extra-spaces
          trim
          autocomplete="address-level2"
          required
          maxlength="40"
          :state="getValidationState(validationContext)"
          :disabled="isSubmitting"
        />
        <ErreurValidation
          id="ville-live-feedback"
          :message="validationContext.errors[0]"
          :variables="variablesARemplacer"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>

    <!-- Code postal et Province -->
    <b-row>
      <div class="col-6">
        <CodePostal :content="content" :disabled="isSubmitting" />
      </div>

      <div class="d-flex flex-column align-items-start col-6">
        <div class="mb-3 mb-md-2 font-weight-bold">
          {{ content.libProvince }}
        </div>
        <div>{{ content.libQuebec }}</div>
      </div>
    </b-row>
  </ValidationObserver>

  <!-- Modale de confirmation d'adresse (tous les modes) -->
  <AdresseConfirmationModale
    v-if="showConfirmationModal"
    class="compteClair"
    :visible="showConfirmationModal"
    :mode="modalMode"
    :labels="modalLabels"
    :entered-address="enteredAddress"
    :suggested-address="modalSuggestedAddress"
    :validation-results="modalValidationResults"
    :show-validation-dropdown="showModalValidationDropdown"
    @close="handleModalClose"
    @continue="handleModalContinue"
    @continue-without-validation="handleContinueWithoutValidation"
    @modify-address="handleModifyAddress"
    @address-select="handleModalAddressSelect"
    @update:selectedAddress="handleSelectedAddressChange"
  />
</div>
